<template>
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M100 50.0002C100 77.6146 77.6146 100 50.0002 100C22.3857 100 0 77.6146 0 50.0002C0 22.3857 22.3857 0 50.0002 0C77.6146 0 100 22.3857 100 50.0002Z"
        fill="#FFF2E0"
      />
      <path
        d="M93.2574 50.0001C93.2574 73.8907 73.8906 93.2576 50 93.2576C26.1095 93.2576 6.74268 73.8907 6.74268 50.0001C6.74268 26.1095 26.1095 6.74268 50 6.74268C73.8906 6.74268 93.2574 26.1095 93.2574 50.0001Z"
        fill="#FFF2E0"
      />
      <path
        d="M82.2446 60.1845C82.2446 53.9391 77.9743 48.6915 72.1943 47.2029V30.9195C72.1943 29.3549 71.0869 28.0487 69.613 27.7412C69.3063 26.2682 68.0001 25.1608 66.4355 25.1608H54.8836L52.2868 22.564H29.376C27.5832 22.564 26.1306 24.0174 26.1306 25.8102V73.2691C26.1306 74.8583 27.2732 76.1808 28.7814 76.4605C29.021 77.7528 30.0254 78.776 31.3079 79.0434C31.6146 80.5173 32.9208 81.6247 34.4854 81.6247H68.9481C70.7409 81.6247 72.1935 80.1705 72.1935 78.3785V73.166C77.9743 71.6767 82.2446 66.4291 82.2446 60.1845Z"
        fill="#FFE5C2"
      />
      <path
        d="M68.9482 78.6927H34.4862C32.6934 78.6927 31.24 77.2393 31.24 75.4473V29.2863C31.24 27.4934 32.6934 26.04 34.4862 26.04H68.9482C70.741 26.04 72.1944 27.4934 72.1944 29.2863V75.4465C72.1944 77.2393 70.741 78.6927 68.9482 78.6927Z"
        fill="#D1D3D4"
      />
      <path
        d="M68.9482 77.3937H34.4862C32.6934 77.3937 31.24 75.9411 31.24 74.1483V27.9882C31.24 26.1953 32.6934 24.7419 34.4862 24.7419H68.9482C70.741 24.7419 72.1944 26.1953 72.1944 27.9882V74.1483C72.1944 75.9411 70.741 77.3937 68.9482 77.3937Z"
        fill="white"
      />
      <path
        d="M66.4355 76.1801H31.9737C30.1809 76.1801 28.7275 74.7267 28.7275 72.9347V26.7736C28.7275 24.9807 30.1809 23.5273 31.9737 23.5273H66.4355C68.2283 23.5273 69.6817 24.9807 69.6817 26.7736V72.9339C69.6817 74.7267 68.2283 76.1801 66.4355 76.1801Z"
        fill="#D1D3D4"
      />
      <path
        d="M66.4355 74.8812H31.9737C30.1809 74.8812 28.7275 73.4287 28.7275 71.6359V25.4757C28.7275 23.6829 30.1809 22.2295 31.9737 22.2295H66.4355C68.2283 22.2295 69.6817 23.6829 69.6817 25.4757V71.6359C69.6817 73.4287 68.2283 74.8812 66.4355 74.8812Z"
        fill="#E6E7E8"
      />
      <path
        d="M53.5848 20.9307H29.376C27.5832 20.9307 26.1306 22.3841 26.1306 24.1769V70.3371C26.1306 72.1299 27.5832 73.5833 29.376 73.5833H63.8387C65.6316 73.5833 67.0841 72.1299 67.0841 70.3371V34.4308L53.5848 20.9307Z"
        fill="#D1D3D4"
      />
      <path
        d="M52.2868 19.6326H29.376C27.5832 19.6326 26.1306 21.0851 26.1306 22.878V69.0381C26.1306 70.8309 27.5832 72.2843 29.376 72.2843H63.8387C65.6316 72.2843 67.0841 70.8309 67.0841 69.0381V34.4307L52.2868 19.6326Z"
        fill="white"
      />
      <path
        d="M60.6304 41.4139H32.5849C31.8684 41.4139 31.2869 40.8332 31.2869 40.1159C31.2869 39.3987 31.8676 38.8171 32.5849 38.8171H60.6304C61.3477 38.8171 61.9292 39.3978 61.9292 40.1159C61.9292 40.8332 61.3477 41.4139 60.6304 41.4139Z"
        fill="#D0D2D3"
      />
      <path
        d="M60.6304 49.2912H32.5849C31.8684 49.2912 31.2869 48.7096 31.2869 47.9923C31.2869 47.2759 31.8676 46.6943 32.5849 46.6943H60.6304C61.3477 46.6943 61.9292 47.275 61.9292 47.9923C61.9292 48.7096 61.3477 49.2912 60.6304 49.2912Z"
        fill="#D0D2D3"
      />
      <path
        d="M60.6304 57.1684H32.5849C31.8684 57.1684 31.2869 56.5868 31.2869 55.8695C31.2869 55.1521 31.8676 54.5706 32.5849 54.5706H60.6304C61.3477 54.5706 61.9292 55.1521 61.9292 55.8695C61.9292 56.5868 61.3477 57.1684 60.6304 57.1684Z"
        fill="#D0D2D3"
      />
      <path
        d="M60.6304 65.0453H32.5849C31.8684 65.0453 31.2869 64.4638 31.2869 63.7465C31.2869 63.03 31.8676 62.4485 32.5849 62.4485H60.6304C61.3477 62.4485 61.9292 63.0292 61.9292 63.7465C61.9292 64.4638 61.3477 65.0453 60.6304 65.0453Z"
        fill="#D0D2D3"
      />
      <path
        d="M67.085 34.4307H55.5331C53.7403 34.4307 52.2869 32.9773 52.2869 31.1845V19.6326L67.085 34.4307Z"
        fill="#BBBDBF"
      />
      <path
        d="M71.9216 44.2145C64.7176 42.5133 57.4981 46.9749 55.7969 54.1797C54.0957 61.3837 58.5564 68.6032 65.7612 70.3045C72.966 72.0057 80.1856 67.5441 81.8868 60.3401C83.588 53.1353 79.1264 45.9158 71.9216 44.2145Z"
        fill="#FBC1CE"
      />
      <path
        d="M71.2804 46.9322C65.5765 45.5852 59.8611 49.1176 58.514 54.8208C57.1678 60.5249 60.6994 66.2403 66.4034 67.5874C72.1065 68.9336 77.8219 65.402 79.169 59.698C80.516 53.9948 76.9836 48.2793 71.2804 46.9322Z"
        fill="#FDE3E9"
      />
      <path
        d="M63.7579 62.3364C62.9948 61.5733 62.9948 60.3358 63.7579 59.5727L71.1606 52.1691C71.9237 51.4068 73.1611 51.4068 73.9242 52.1691C74.6873 52.9322 74.6873 54.1697 73.9242 54.9336L66.5215 62.3364C65.7584 63.0994 64.521 63.0994 63.7579 62.3364Z"
        fill="#D32027"
      />
      <path
        d="M73.9243 62.3364C73.1612 63.0994 71.9238 63.0994 71.1607 62.3364L63.758 54.9336C62.9941 54.1705 62.9941 52.933 63.758 52.1691C64.5203 51.4068 65.7577 51.4068 66.5216 52.1691L73.9243 59.5727C74.6874 60.3358 74.6874 61.5733 73.9243 62.3364Z"
        fill="#D32027"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
